import React, { CSSProperties, FC, ReactNode } from "react";
// import { Container } from "react-bootstrap";

import Footer from "components/common/Footer/Footer";
import TestHeader from "components/common/TestHeader/TestHeader";

interface IProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const MainLayout: FC<IProps> = ({ children, className, style }) => {
  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{ minHeight: "100vh" }}
    >
      <TestHeader />
      <div
        className={className}
        style={{
          width: "90%",
          margin: "0 auto",
          flex: "1",
          padding:"50px 0",
          ...style,
        }}
      >
        {children}
      </div>
      <Footer />
    </div>
  );
};

export { MainLayout };
